/* eslint-disable no-shadow */
import axios from 'axios';

const api = process.env.VUE_APP_API;

const state = {
  questions: [],
};

const getters = {};

const mutations = {
  SET_QUESTIONS(state, data) {
    state.questions = data;
  },
};

const actions = {
  async get(context) {
    try {
      const results = await axios.get(`${api}/question`);
      context.commit('SET_QUESTIONS', results.data);
    } catch (error) {
      console.error('Error while getting questions: ', error);
    }
  },
  async create(context, data) {
    return axios.post(`${api}/question`, data);
  },
  async edit(context, data) {
    return axios.put(`${api}/question/${data.id}`, data);
  },
  async delete(context, data) {
    return axios.delete(`${api}/question/${data.id}`);
  },
  async getForClient(context, token) {
    try {
      const results = await axios.get(`${api}/question/${token}`);
      context.commit('SET_QUESTIONS', results.data);
    } catch (error) {
      console.error('Error while getting questions for client: ', error);
    }
    return null;
  },
  async getForAdminClient(context, token) {
    try {
      const results = await axios.get(`${api}/admin/question/${token}`);
      context.commit('SET_QUESTIONS', results.data);
    } catch (error) {
      console.error('Error while getting questions for client: ', error);
    }
    return null;
  },
  async sendResult(context, data) {
    try {
      return await axios.post(`${api}/answer`, data);
    } catch (error) {
      console.error('Error while posting answer: ', error);
    }
    return null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
